
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import MoonLoader from 'react-spinners/MoonLoader';
import { COLORS, INVOICE_STATUSES, USER_TYPES } from '../../config';
import FieldWithEdit from '../../components/FieldItems/FieldWithEdit';
import EditIcon from '../../components/Icons/outline/EditIcon';
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import FieldWithSelectEdit from '../../components/FieldItems/FieldWithSelectEdit';
import useInvoices from '../../store/invoices/invoicesContext';
import RedButton from '../../components/Buttons/RedButton';
import DeleteInvoiceModal from './DeleteInvoiceModal';
import useApp from '../../store/app/appContext';
import DownloadIcon from '../../components/Icons/outline/DownloadIcon';
import dayjs from 'dayjs';

function ViewInvoiceDetails({
  invoiceId: id
}) {

  const {
    appState: { user },
  } = useApp();

  const history = useHistory();
  const { getInvoiceDetails, updateInvoiceStatus, deleteInvoice, downloadInvoice } = useInvoices();
  const [showDeleteInvoiceModal, setShowDeleteInvoiceModal] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [invoice, setInvoice] = React.useState({});
  const [edit, setEdit] = React.useState(false);

  useEffect(() => {
    (async function fetchDetails() {
      await getInvoiceDetails(id).then(res => {
        const details = {
          id: res._id,
          amount: res.amount,
          name: res.user_id.first_name + ' ' + res.user_id.last_name,
          status: res.status.slice(-1)[0].status,
          fileName: res.file_name
        }
        setInvoice(details);
        setIsLoading(false);
      }).catch((err) => {
          history.goBack()
      })
    })();
  }, [id])

  
  const handleUpdateClick = () => {
    updateInvoiceStatus(invoice.id, invoice.status).then(() => {
      setEdit(false);
    });
  }

  const handleEditClick = (field) => {
    if (edit === field) setEdit(false)
    if (edit !== field) setEdit(field)
  }

  if (isLoading) return (
    <div className='flex justify-around items-center h-full'>
      <MoonLoader color={COLORS.colorPrimary}/>
    </div>
  )

  const statusTypeOptions = [];
  if (!statusTypeOptions.length) INVOICE_STATUSES.map(type => (
    statusTypeOptions.push({
      label: type,
      value: type
    })
  ));

  const handleDeleteInvoice = (InvoiceInfo) => {
    deleteInvoice(InvoiceInfo.id).then(res => {
      window.location.reload();
    })
    setShowDeleteInvoiceModal(false)
  }

  const handleDownloadInvoice = () => {
    downloadInvoice(invoice.id, invoice.fileName)
  }

  return (
    <div className="flex flex-col">
       <DeleteInvoiceModal
        showDeleteInvoiceModal={showDeleteInvoiceModal}
        setShowDeleteInvoiceModal={setShowDeleteInvoiceModal}
        onDelete={() => handleDeleteInvoice(invoice)}
      />
      <div className="bg-white rounded shadow py-12 px-10">
        <div className='flex justify-between items-center'>
          <h1 className="mb-10 text-2xl text-secondary">Invoice details</h1>
          <div className={`${edit ? 'rounded-full h-10 w-10 bg-primary flex justify-center items-center' : 'rounded-full h-10 w-10 bg-white flex justify-center items-center'}`}>
             {user.user_type !== USER_TYPES.PARTNER && <EditIcon stroke={edit ? 'white' : COLORS.colorSecondary} onClick={() => handleEditClick(true)} className='cursor-pointer'/>}
          </div>
        </div>
        <div className='grid grid-cols-1 gap-y-4'>  
          <FieldWithEdit locked label='Name' data={invoice.name}/>
          <FieldWithEdit locked label='Amount' data={invoice.amount}/>
          <FieldWithEdit locked label='Date' data={dayjs(invoice.invoice_date).format('DD/MM/YYYY')}/>
          <FieldWithSelectEdit label='Status' options={statusTypeOptions} onChange={(e) => setInvoice({...invoice, status: e.value})} data={invoice.status} edit={edit}/>
          <FieldWithEdit 
            button 
            buttonText={'Download'} 
            buttonOnClick={handleDownloadInvoice}
            label='Invoice' 
            data={invoice.fileName} 
            edit={true}
            showDownloadIcon={true}
            icon={<DownloadIcon stroke={COLORS.colorSecondary} className='mr-3'/>}
          />
          {edit && 
          <div className='flex flex-row-reverse'>
            <div className='w-32'>
              <PrimaryButton className="mt-8" text='Save' onClick={handleUpdateClick} />
            </div>
          </div>}
        </div>
      </div>

      <div className='w-full flex flex-row-reverse pb-4'>
        <PrimaryButton className="w-32 mt-8" text='Back' onClick={() => history.goBack()} />
        {
          user.user_type !== USER_TYPES.PARTNER && <RedButton className="w-32 mr-4 mt-8" text={'Delete invoice'} onClick={() => setShowDeleteInvoiceModal(true)} />
        }
      </div>
    </div>
  )
}

export default ViewInvoiceDetails
